import { BrowserModule }             from '@angular/platform-browser';
import { ErrorHandler, NgModule }    from '@angular/core';
import { IonicApp, IonicModule }     from 'ionic-angular';
import { SplashScreen }              from '@ionic-native/splash-screen';
import { StatusBar }                 from '@ionic-native/status-bar';

import { CalendarModule }            from "ion2-calendar";

import { MyApp }                     from './app.component';
import { UnhandledExceptionHandler } from '../services/UnhandledExceptions';
import { MLText }                    from '../services/MLText';
import { AppDataBroker }             from '../services/AppData';
import { ExceptionPage }             from '../pages/exception/exception';
import { LoadingPage }               from '../pages/loading/loading';
import { SignInPage }                from '../pages/sign-in/sign-in';
import { SelectLangPopoverPage }     from '../pages/sign-in/select-lang-popover';
import { WelcomePage }               from '../pages/welcome/welcome';
import { TemplatePage }              from '../pages/template/template';
import { HousekeepingPage }          from '../pages/housekeeping/housekeeping';
import { DetailsPage }               from '../pages/details/details';
import { EnablePage }                from '../pages/enable/enable';
import { EnableHelpPage }            from '../pages/enable/enable';
import { DiscountsPage }             from '../pages/discounts/discounts';
import { DiscountCalPage }           from '../pages/discount-cal/discount-cal';
import { RoomTypesPage }             from '../pages/roomtypes/roomtypes';
import { AvailabilityPage }          from '../pages/availability/availability';
import { OfferTypesPage }            from '../pages/offertypes/offertypes';
import { CustomPackagesPage }        from '../pages/custom-packages/custom-packages';
import { EarlyBirdPage }             from '../pages/earlybird/earlybird';
import { ChannelPage }               from '../pages/channel/channel';
import { RatesPage }                 from '../pages/rates/rates';
import { RoomsPage }                 from '../pages/rooms/rooms';
import { StaffPage }                 from '../pages/staff/staff';
import { ChangePINPopoverPage }      from '../pages/staff/change-pin-popover';
import { TaskListPage }              from '../pages/task-list/task-list';
import { TaskReportPage }            from '../pages/task-report/task-report';
import { DescriptionsPage }          from '../pages/descriptions/descriptions';
import { PhotosPage }                from '../pages/photos/photos';
import { DocsPage}                   from '../pages/docs/docs';
import { MapsPage }                  from '../pages/maps/maps';
import { FacilitiesPage }            from '../pages/facilities/facilities';
import { CancellationPage }          from '../pages/cancellation/cancellation';
import { BookingsPage }              from '../pages/bookings/bookings';
import { BookingDetailsPage }        from '../pages/bookings/booking-details';
import { ChangePasswordPage }        from '../pages/change-password/change-password';
import { PaymentPage }               from '../pages/payment/payment';
import { SpotlightPage }             from '../pages/spotlight/spotlight';
import { PMSPage }                   from '../pages/pms/pms';

@NgModule({
    declarations: [
         MyApp
        ,ExceptionPage
        ,LoadingPage
        ,SignInPage
        ,SelectLangPopoverPage
        ,WelcomePage
        ,TemplatePage
        ,HousekeepingPage
        ,DetailsPage
        ,EnablePage
        ,EnableHelpPage
        ,DiscountsPage
        ,DiscountCalPage
        ,RoomTypesPage
        ,AvailabilityPage
        ,OfferTypesPage
        ,CustomPackagesPage
        ,EarlyBirdPage
        ,ChannelPage
        ,RatesPage
        ,RoomsPage
        ,StaffPage
        ,ChangePINPopoverPage
        ,TaskListPage
        ,TaskReportPage
        ,DescriptionsPage
        ,PhotosPage
        ,DocsPage
        ,MapsPage
        ,FacilitiesPage
        ,CancellationPage
        ,BookingsPage
        ,BookingDetailsPage
        ,ChangePasswordPage
        ,PaymentPage
        ,SpotlightPage
        ,PMSPage
    ]
    ,imports: [
         CalendarModule
        ,BrowserModule
        ,IonicModule.forRoot(MyApp)
    ]
    ,bootstrap: [
         IonicApp
    ]
    ,entryComponents: [
         MyApp
        ,ExceptionPage
        ,LoadingPage
        ,SignInPage
        ,SelectLangPopoverPage
        ,WelcomePage
        ,TemplatePage
        ,HousekeepingPage
        ,DetailsPage
        ,EnablePage
        ,EnableHelpPage
        ,DiscountsPage
        ,DiscountCalPage
        ,RoomTypesPage
        ,AvailabilityPage
        ,OfferTypesPage
        ,CustomPackagesPage
        ,EarlyBirdPage
        ,ChannelPage
        ,RatesPage
        ,RoomsPage
        ,StaffPage
        ,ChangePINPopoverPage
        ,TaskListPage
        ,TaskReportPage
        ,DescriptionsPage
        ,PhotosPage
        ,DocsPage
        ,MapsPage
        ,FacilitiesPage
        ,CancellationPage
        ,BookingsPage
        ,BookingDetailsPage
        ,ChangePasswordPage
        ,PaymentPage
        ,SpotlightPage
        ,PMSPage
    ]
    ,providers: [
         StatusBar
        ,SplashScreen
        ,UnhandledExceptionHandler
        ,{ provide: ErrorHandler ,useExisting: UnhandledExceptionHandler }
        ,MLText
        ,AppDataBroker
    ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts